import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useFormatMessage } from '../../i18n-review/client/Msg';

const messages = defineMessages({
  label: {
    id: 'marketingConsent.checkbox.label',
    defaultMessage: 'Also send me job market emails and tips from JobCrawls (optional, unsubscribe anytime).',
    description: 'Label for the standalone, unticked marketing-email opt-in checkbox — kept separate from job-alert consent',
  },
});

export interface MarketingConsentCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
}

/**
 * Deliberately its own visual block (border-top divider), separate from any
 * job-alert consent copy: bundling marketing consent with a transactional
 * consent (or pre-checking it) is not valid unbundled consent under GDPR.
 */
export function MarketingConsentCheckbox({
  checked,
  onChange,
  disabled,
  id = 'marketing-consent-checkbox',
}: MarketingConsentCheckboxProps) {
  const intl = useIntl();
  const formatMessage = useFormatMessage();

  return (
    <div className="mt-3 border-t border-jc-border/60 pt-3">
      <label htmlFor={id} className="flex items-start gap-2 text-sm text-jc-muted">
        <input
          id={id}
          type="checkbox"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-0.5 h-4 w-4 flex-shrink-0"
        />
        <span>{formatMessage(messages.label)}</span>
      </label>
    </div>
  );
}
